import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env';
import { EmailCampaignIssueStatistics, EmailStatsChartsLabels } from '@models/email/email-issue';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AtlasToastService } from '@services/atlas-toast.service';
import { EmailHistoryService } from '@services/email-history.service';
import { ChartData, ChartOptions, ChartType } from 'chart.js';
// import { Color, Label, MultiDataSet } from 'ng2-charts';

@Component({
  selector: 'wsb-email-stats',
  templateUrl: './email-stats.component.html',
  styleUrls: ['./email-stats.component.scss'],
  standalone: false
})
export class EmailStatsComponent implements OnInit {
  @ViewChild('modalConfirmExport') modalConfirmExport;
  modalConfirmExportModal: NgbModalRef;

  emailStats: EmailCampaignIssueStatistics;
  emailCampaignIssueId;
  delivered;
  public doughnutChartType: ChartType = 'doughnut';

  public doughnutLegend = false;
  public doughnutType: ChartType = 'doughnut';
  public doughnutLabels: string[] = [];
  public doughnutOptions?: ChartOptions<'doughnut'> = {
    responsive: true,
    cutout: 90,
    plugins: {
      tooltip: {
        enabled: false
      }
    }
  };

  public doughnutDeliveredData: ChartData<'doughnut'> = {
    datasets: [
      {
        data: [0, 1],
        label: '',
        backgroundColor: [environment.chartsColorPalette[0], '#f3f3f3'],
        borderColor: environment.chartsColorPalette[2],
        hoverBorderColor: environment.chartsColorPalette[3]
      }
    ]
  };
  public doughnutDeliveredLabels: string[] = [];
  public doughnutOpenedData: ChartData<'doughnut'> = {
    datasets: [
      {
        data: [0, 1],
        label: '',
        backgroundColor: [environment.chartsColorPalette[0], '#f3f3f3'],
        borderColor: environment.chartsColorPalette[2],
        hoverBorderColor: environment.chartsColorPalette[3]
      }
    ]
  };
  public doughnutOpenedLabels: string[] = [];
  public doughnutUnsubData: ChartData<'doughnut'> = {
    datasets: [
      {
        data: [0, 1],
        label: '',
        backgroundColor: [environment.chartsColorPalette[0], '#f3f3f3'],
        borderColor: environment.chartsColorPalette[2],
        hoverBorderColor: environment.chartsColorPalette[3]
      }
    ]
  };
  public doughnutUnsubLabels: string[] = [];

  constructor(
    private emailHistoryService: EmailHistoryService,
    private translateService: TranslateService,
    private location: Location,
    private modalService: NgbModal,
    private atlasToast: AtlasToastService,
    private activateRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.getIdCampaignFromRouting();
    setTimeout(() => {
      this.translateChartsLabels();
    }, 1000);
    this.getEmailCampaignIssueStatistics(this.emailCampaignIssueId);
  }

  getEmailCampaignIssueStatistics(idCampaignIssue?) {
    this.emailHistoryService.getEmailCampaignIssueStatistics(idCampaignIssue).subscribe(stats => {
      this.emailStats = stats;
      this.doughnutDeliveredData.datasets[0].data = [this.emailStats.numSent, this.emailStats.numBounces];
      this.doughnutOpenedData.datasets[0].data = [
        this.emailStats.intNumUniqueOpens,
        this.emailStats.numSent - this.emailStats.intNumUniqueOpens
      ];
      this.doughnutUnsubData.datasets[0].data = [this.emailStats.intNumUnsubscribe, this.emailStats.numSent];
      this.delivered =
        ((this.emailStats.numSent - this.emailStats.numBounces) / (this.emailStats.numSent + this.emailStats.numBounces)) * 100;
      this.delivered = (Math.round(this.delivered * 100) / 100).toFixed(2);
    });
  }

  private getIdCampaignFromRouting() {
    this.emailCampaignIssueId = this.activateRoute.snapshot.paramMap.get('id');
  }

  private translateChartsLabels() {
    const bouncesLabel = this.translateService.instant(EmailStatsChartsLabels.BOUNCES);
    const deliveredLabel = this.translateService.instant(EmailStatsChartsLabels.DELIVERED);
    this.doughnutDeliveredLabels = [deliveredLabel, bouncesLabel];
  }

  goBack() {
    this.location.back();
  }

  openExportConfirmationModal() {
    this.modalConfirmExportModal = this.modalService.open(this.modalConfirmExport);

    this.modalConfirmExportModal.result.then(
      result => {
        this.exportCampaignIssueStats(this.emailCampaignIssueId);
      },
      reason => {}
    );
  }

  exportCampaignIssueStats(emailCampaignId) {
    this.emailHistoryService.exportCsv(emailCampaignId).subscribe(() => {
      this.atlasToast.success('common_success', null);
    });
  }

  closeExportModal() {
    this.modalConfirmExportModal.close();
  }
}
